<template>
  	<div class="retail-instance-list init">
	    <div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('privateNetInstance.cps')" />
				<div class="jc-box-action">
					<a v-bind:href="Config.CPS_HELP_URL" target="_blank">
					    {{ $t('privateNetInstance.helpDoc') }}
					</a>
				</div>
	      	</div>
	      	<div class="jc-page-content">
		        <div class="jc-container-table">
		          	<div class="jc-container-table-actionBar flex-display">
			            <el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line"
								    class="jc-button-icon"
								    @click="iconRefreshList">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in regions"
										:key="index"
										:label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="jumpToCreate">
									{{ $t('privateNetInstance.create') }}
								</el-button>
							</el-form-item>
			            </el-form>
						<div class="search-input-list">
							<jcb-combined-search 
								ref='combinedSearch'
								:filterGroup="filterGroup"
								:defaultKey="defaultKey"
								:tags="tags" 
								:matchKeyFunction="matchKeyFunction"
								:noMatchedSearchKeyTip="$t('list.keySearch')"
								:matchSearchKeyIntroduction="$t('list.keySearchTip')"
								@search="handleSearch"/>
							<el-form :inline="true">
								<!--tag-->
								<el-form-item>
									<jcb-tag-filter :service-code="ServiceCodeConstant.CPS"
										:region-id="region" @checkedTags="filterWithCheckedTags">
									</jcb-tag-filter>
								</el-form-item>
								<!--自定义设置-->
								<el-form-item>
									<el-button class="jc-button-icon operate-icon"
									icon="el-icon-setting" @click="customVisible = true"
									:title="$t('listPage.text.customList')">
									</el-button>
								</el-form-item>
								<el-form-item>
									<el-button class="jc-button-icon operate-icon"
										icon="jc-icon-download"
										@click="showDownload"
										:title="$t('listPage.text.exportList')">
									</el-button>
								</el-form-item>
							</el-form>
						</div>
		          	</div>
					<div v-if="searchList" class="search-list">
						 <span>{{this.totalCount === 0 ? $t('list.searchresult1', [totalCount]) : $t('list.searchresult2', [totalCount])}}</span>
						 <el-button type="text"
							@click="backTolist()">{{$t('list.backTolist')}}
						</el-button>
					</div> 
		          	<el-table 
		          		ref="multipleTable"
		          		:data="tableData"
		            	style="width: 100%"
		            	@selection-change="handleSelectionChange"
		                @filter-change="filterChange"
		                class="jc-table-header-cell jc-list-table"
		                :empty-text="$t('speechCraft.listEmptyText')"
		                v-loading="loading">
		                <!-- 多选框-->
		                <el-table-column
					    	type="selection"
					    	width="55"
							v-if="customInfo !== null">
					    </el-table-column>
			            <!--ID/实例名称-->
			            <el-table-column :label="$t('privateNetInstance.listTitle.name')"
			                key="id"
			                v-if="customInfo !== null && customInfo['id'].selected"
			                width="270">
							<template slot-scope="scope">
								<div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()">
									<el-tooltip  placement="top" :content="scope.row.instanceId">	
										<div class="left"  >
											<p>{{ scope.row.instanceId}}</p>
										</div>
									</el-tooltip>										
									<div class="right" v-show="copyHover">
										<copy-value :copyVal="`${scope.row.instanceId}`"></copy-value>	
									</div>	
								</div>
								<div>
									<el-tooltip placement="top" :content="scope.row.name">
										<a href="javascript:void(0)"
											@click="jumpToInstanceDetail(scope.row.instanceId, scope.row.region, scope.row.az, scope.row.sn)"
											class="instance-id">
											{{ scope.row.name }}
										</a>
									</el-tooltip>
									<el-tooltip placement="top"></el-tooltip>
								</div>
								<!--操作系统图片-->
								<div>
									<el-tooltip class="item"
										effect="dark"
										:content="scope.row.osName"
										placement="top">
										<span :class="[scope.row.osType, 'os-icon']"></span>
									</el-tooltip>
								</div>
							</template>
			            </el-table-column>
			            <!--性能监控-->
			            <el-table-column :label="$t('privateNetInstance.listTitle.monitor')" 
			            	v-if="customInfo !== null && customInfo['monitor'].selected"
			            	min-width="80">
				            <template slot-scope="scope">
				                <performance-monitor-icon
									:data="scope.row"
									@click.native="jumpToInstanceDetail(
										scope.row.instanceId,
										scope.row.region,
										scope.row.az,
										scope.row.sn,
										'performanceMonitor',
										scope.row.imageType,
									)" />
				            </template>
			            </el-table-column>
			            <!--可用区-->
			            <el-table-column :filter-multiple="true"
							column-key="az"
							prop="az"
							min-width="85"
							:filters="filters.azs"
							:filter-method="filterAz"
							:label="$t('privateNetInstance.listTitle.region')"
							key="az"
							v-if="customInfo !== null && customInfo['az'].selected">
							<template slot-scope="scope">
								{{ transformAz(scope.row.az) }}
							</template>
			            </el-table-column>
			            <!--机柜编码-->
			            <el-table-column
							column-key="cabinet"
							prop="cabinet"
							min-width="120"
							:label="$t('detail.text.cabinet')"
							key="cabinet"
							v-if="customInfo !== null && customInfo['cabinet'].selected">
							<template slot-scope="scope">
								{{ scope.row.cabinet}}
							</template>
			            </el-table-column>
			            <!--Net-POD-->
			            <el-table-column
							column-key="podName"
							prop="podName"
							min-width="85"
							:label="$t('detail.text.podName')"
							key="netPod"
							v-if="customInfo !== null && customInfo['netPod'].selected">
							<template slot-scope="scope">
								{{scope.row.podName + ' (' + scope.row.podDescription + ')'}}
							</template>
			            </el-table-column>
			            <!--网络接口数量-->
			            <el-table-column :filter-multiple="true"
							column-key="interfaceMode"
							prop="interfaceMode"
							min-width="120"
							:filters="filters.interfaceModes"
							:filter-method="filterInterfaceMode"
							:label="$t('eip.text.internetAccessType')"
							key="interfaceMode"
							v-if="customInfo !== null && customInfo['interfaceMode'].selected">
							<template slot-scope="scope">
								{{scope.row.interfaceMode==='dual'?$t('create.text.doubleInternetAccess'):$t('create.text.singleInternetAccess')}}
							</template>
			            </el-table-column>
			            <!--主IP地址-->
			            <el-table-column 
			            	:label="$t('listPage.tableLabel.targetIpAddress')"
							key="ip" min-width="165"
							v-if="customInfo !== null && customInfo['ip'].selected">
							<template slot-scope="scope">
								<div class="inline-ip"  @mouseover="ipHover()" @mouseout="ipDisplayNone()" v-if="scope.row.privateIp">
									<el-tooltip  placement="top" :content="scope.row.privateIp + $t('privateNetInstance.private')">
										<div class="left">
											<p class="instance-ip">{{ scope.row.privateIp + $t('privateNetInstance.private') }}		
											</p>
										</div>
									</el-tooltip>
									<div class="right" v-show="copyHover">
										<copy-value :copyVal="`${scope.row.privateIp}`"></copy-value>	
									</div>
								</div>
							</template>
			            </el-table-column>
			            <!--网络类型-->
			            <el-table-column :label="$t('privateNetInstance.listTitle.netType')"
							key="networkType"
							min-width="100"
							v-if="customInfo !== null && customInfo['networkType'].selected">
		              		<template slot-scope="scope">
								<span>
									{{ $t('retailInstance.text.retailInstanceNet') }}
								</span>
			              	</template>
			            </el-table-column>
			            <!--带外管理IP-->
			            <el-table-column :label="$t('detail.text.iloIp')"
							key="iloIp"
							min-width="110"
							v-if="customInfo !== null && customInfo['iloIp'].selected">
		              		<template slot-scope="scope">
								{{ scope.row.iloIp }}
			              	</template>
			            </el-table-column>
			            <!--状态-->
			            <el-table-column :filter-multiple="true"
							column-key="status"
							:filters="filters.status"
							:filter-method="filterStatus"
							:label="$t('privateNetInstance.listTitle.status')"
							key="status"
							prop="status"
							v-if="customInfo !== null && customInfo['status'].selected"
							min-width="100">
			              	<template slot-scope="scope">
								<el-tooltip v-if="scope.row.status === 'error'"
									:content="$t('privateNetInstance.clickCommit')"
									placement="top">
									<span @click="createErrorOrder"
									    :class="['my-error-status', 'jc-status-danger']"
									    v-if="scope.row.status === 'error'">
									{{transFormStatusName(scope.row.status)}}
									</span>
								</el-tooltip>
								<span v-else :class="getClassByStatue(scope.row.status)">
								<span class="icon-status icon-stopped icon-run"
								    v-if="scope.row.status !== 'running' && scope.row.status !== 'stopped'">
								</span>
								{{ transFormStatusName(scope.row.status) }}
								</span>
			              	</template>
			            </el-table-column>
			            <!--规格类型-->
			            <el-table-column 
			            	:filter-multiple="true"
							column-key="deviceType"
							:filters="filters.deviceTypes"
							:filter-method="filterDeviceType"
							prop="deviceType"
							:label="$t('privateNetInstance.listTitle.spc')"
							key="specifications"
							v-if="customInfo !== null && customInfo['specifications'].selected"
							min-width="115">
							<template scope="scope">
								<el-tooltip class="item"
								    :content="scope.row.cpsConfiguration.deviceType.name"
								    effect="dark">
								  	<span class="english-wrap">{{ scope.row.cpsConfiguration.deviceType.name }}</span>
								</el-tooltip>
							</template>
			            </el-table-column>
			            <!--配置-->
			            <el-table-column :label="$t('privateNetInstance.listTitle.config')"
							key="config"
							v-if="customInfo !== null && customInfo['config'].selected"
							min-width="120">
							<template slot-scope="scope">
								<p>{{scope.row.cpsConfiguration.cpu}}</p>
								<p>{{scope.row.cpsConfiguration.mem}}</p>
							</template>
			            </el-table-column>
			            <!--标签-->
			            <el-table-column :label="$t('listPage.text.tags')"
							key="tag"
							v-if="customInfo !== null && customInfo['tags'].selected"
							min-width="70"
							class-name="p-line-break">
			              	<template slot-scope="scope">
			                	<p>{{scope.row.tagPairs | maybeEmpty}}</p>
			              	</template>
			            </el-table-column>
			            <!--计费信息-->
			            <el-table-column :label="$t('privateNetInstance.listTitle.charge')"
							key="chargeInfo"
							min-width="200"
							v-if="customInfo !== null && customInfo['chargeInfo'].selected">
			              	<template slot-scope="scope">
				                <div v-if="scope.row.charge.chargeExpiredTime !== undefined">
				                  	<p>
				                  		{{transformCharge(scope.row.charge.chargeMode)}}
					                    <span v-if="getCheckExpireInfo(scope.row) === 'will-retire'"
					                        class="expire-warning">
					                    	{{ '(' + $t('listPage.text.hasExpired') + ')' }}
					                  	</span>
				                  	</p>
                                    <p class="list-expire-p">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                    </p>
				                  	<p class="expire-warning list-expire-p bill-info-tip"
										v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.charge.chargeRetireTime">
										{{scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed')}}
				                  	</p>
				                  	<p class="expire-warning list-expire-p bill-info-tip"
										v-if="getCheckExpireInfo(scope.row) === 'will-expire'">
										{{scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired')}}
				                  	</p>
									<p v-if="getCheckExpireInfo(scope.row) === 'available'"
										class="list-expire-p bill-info-tip">
										{{scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired')}}
									</p>
				                </div>
				                <div v-else-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
									<p>
										{{transformCharge(scope.row.charge.chargeMode)}}
										<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
											class="expire-warning expire-warning">
											{{ '(' + $t('privateNetInstance.arrear') + ')' }}
										</span>
									</p>
									<p class="list-expire-p bill-info-tip"
										 v-if="scope.row.charge.chargeStatus === 'normal'">
										{{scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create')}}
									</p>
									<p class="list-expire-p expire-warning"
										 v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
										{{scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed')}}
									</p>
								</div>
				                <div v-else>
				                	<span>--</span>
				                </div>
			              	</template>
			            </el-table-column>
			            <!--操作-->
			            <el-table-column 
			            	:label="$t('privateNetInstance.listTitle.operate')"
			                key="operation"
			                v-if="customInfo !== null && customInfo['operation'].selected">
			              	<template slot-scope="scope">
				                <operate-unit
				                	v-if="['stopped', 'stopping', 'error', 'reinstalling'].includes(scope.row.status)" 
				                	:operateName="$t('privateNetInstance.open')"
				                    :disabled="OverdueConstantArray.includes(scope.row.charge.chargeStatus)
				                    || operateMap[statusListMap[scope.row.status]].indexOf('start') > -1
									|| !scope.row.charge.chargeStatus"
				                    @handleClick="clickOperateOpen"
				                    :instanceInfo="scope.row"
				                    :operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo')
												: OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip')
												: $t('privateNetInstance.operations.onlyShutDown')">
				                </operate-unit>
				                <operate-unit
				                	v-else 
				                	:operateName="$t('privateNetInstance.shutdown')"
									:disabled="OverdueConstantArray.includes(scope.row.charge.chargeStatus)
									|| operateMap[statusListMap[scope.row.status]].indexOf('turnOff') > -1
									|| !scope.row.charge.chargeStatus"
									@handleClick="clickOperateShutdown"
									:instanceInfo="scope.row"
									:operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo')
												: OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip')
												: $t('privateNetInstance.operations.onlyRunning')">
				                </operate-unit>
				                <operate-unit :operateName="$t('privateNetInstance.restart')"
									:disabled="operateMap[statusListMap[scope.row.status]].indexOf('restart') > -1
									    || OverdueConstantArray.includes(scope.row.charge.chargeStatus)
										|| !scope.row.charge.chargeStatus"
									@handleClick="clickOperateRestart"
									:instanceInfo="scope.row"
									:operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo')
												: OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip')
												: $t('privateNetInstance.operations.onlyRunning')">
				                </operate-unit>
				                <p>
				                  	<drop-down-operation :showType="'span'"
										:buttonTitle="$t('privateNetInstance.more')"
										:operations="scope.row.operations"
										:rowInfo="scope.row"
										@clickSelectItem="clickOperate">
				                  	</drop-down-operation>
				                </p>
			              	</template>
			            </el-table-column>
		          	</el-table>
		        </div>
		        <open :visible.sync="openInstance"
					:name="instanceInfo.name"
					:instanceId="instanceInfo.instanceId"
					:region="this.region"
					@refresh="operateRefresh">
		        </open>
		        <close :visible.sync="closeInstance"
	               	:name="instanceInfo.name"
	               	:region="this.region"
	               	:instanceId="instanceInfo.instanceId"
	               @refresh="operateRefresh">
		        </close>
		        <restart :visible.sync="restartInstanceVisible"
	                :name="instanceInfo.name"
	                :region="this.region"
	                :instanceId="instanceInfo.instanceId"
	                @refresh="operateRefresh">
		        </restart>
	        	<repassword :visible.sync="repasswordInstance"></repassword>
		        <!--重装系统第一次弹框-->
		        <reinstall :visible.sync="reInstall"
                   :rowInfo="rowInfo"
				   :retailTipChange="retailTipChange"
				   instanceType="retail"
                   @openReConfirm="openReConfirm"
                   v-if="reInstall">
		        </reinstall>
		        <!--重装系统第二次弹框-->
		        <resys :visible.sync="reSysConfirm"
		           :formInfo="reSysForm"
				   :retailTipChange="retailTipChange"
		           :rowInfo="reSystemInfo"
		           @refresh="operateRefresh"
		           v-if="reSysConfirm">
		        </resys>
		        <custom 
		            v-if="customVisible"
		            :visible.sync="customVisible"
		            :optionArr="optionArr"
		            :type="type">
		        </custom>
	      	</div>
	    </div>

	    <div
	    	v-if="listTotal > 0"
	        class="cps-page-footer block jc-container-table-actionBar">
	        <div class="fl mt10" >
	        	<el-checkbox @change="handleCheckAllChange" v-model="hasCheckAll" class="mr20"></el-checkbox>
	        	<el-tooltip placement="top" :disabled="isAllowBatchClose">
	        		<div slot="content">{{multipleSelection.length ? $t('retailInstance.tooltip.turnOff') : $t('retailInstance.tooltip.chooseTips')}}</div>
	        		<span>
	        			<el-button 
		                    type="primary"
							class="w70"
		                    :disabled="!isAllowBatchClose"
		                    @click="showBatchCloseDialog">
		                    {{$t('privateNetInstance.shutdown')}}                    
	               		</el-button>
	        		</span>
	        	</el-tooltip>
               	<el-tooltip placement="top" :disabled="isAllowBatchOpen">
	        		<div slot="content">{{multipleSelection.length ? $t('retailInstance.tooltip.turnOn') : $t('retailInstance.tooltip.chooseTips')}}</div>
	        		<span>
		                <el-button 
		                    type="primary"
							class="w70"
		                    :disabled="!isAllowBatchOpen"
		                    @click="showBatchOpenDialog">
		                    {{$t('privateNetInstance.open')}}                    
		                </el-button>
	        		</span>
	        	</el-tooltip>
              	<drop-down-operation
              		class="batch-operation-button" 
              		:showType="'button'"
					:buttonTitle="$t('privateNetInstance.more')"
					:operations="batchOperations"
					@clickSelectItem="clickBatchOperate">
              	</drop-down-operation>
  		   		<!-- <el-tooltip placement="top" :disabled="isAllowBatchRestart">
	        		<div slot="content">{{multipleSelection.length ? $t('retailInstance.tooltip.restart') : $t('retailInstance.tooltip.chooseTips')}}</div>
	        		<span>
		                <el-button 
		                    type="primary"
		                    :disabled="!isAllowBatchRestart"
		                    @click="showBatchOpenRestart">
		                    {{$t('privateNetInstance.restart')}}                    
		                </el-button> 
	        		</span>
	        	</el-tooltip> -->
            </div>
	      	<el-pagination 
	      		@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageSizes"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="listTotal">
	      	</el-pagination>
	    </div>
	    <reset-password :dialogVisible.sync="resetPasswordDialogVisible" :detail-data="rowInfo"
	    	@refreshData="iconRefreshList">
	    </reset-password>
	    <!--操作保护-->
	    <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType"
	        @success="onSuccess" @error="onError">
	    </jcb-opt-protect>
	    <!--编辑标签-->
	    <jcb-tag-edit :visible.sync="editTagDialogVisible"
	        :service-code="ServiceCodeConstant.CPS"
	        :region-id="rowInfo.region !== undefined ? rowInfo.region : ''"
	        :resource-ids="rowInfo.instanceId !== undefined ? [rowInfo.instanceId] : []"
	        @complete="refreshWithLoading(null, true)">
	    </jcb-tag-edit>
	    <!--删除实例-->
		<delete-instance 
			:visible.sync="deleteVisible"
			@refresh="operateRefresh"
			:rowInfo="rowInfo"
			:pageSource="'list'">		
		</delete-instance>
		<!-- 下载 -->
		<download-selection
			:visible.sync="downloadVisible"
			:currentPage="currentPage"
			:pageSize="pageSize"
			:filterParams="filterParams"
			:searchParams="params"
			:networkType="networkType"
			:multipleSelection="multipleSelection"
			:region="region"
			@refresh="operateRefresh">
		</download-selection>
		<!--批量关机-->
		<batch-close 
			:visible.sync="batchCloseVisible"
			@refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection"
			:showDifferent="showDifferent"
			:region="region">		
		</batch-close>
		<!-- 批量开机 -->
		<batch-open 
			:visible.sync="batchOpenVisible"
			@refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection"
			:showDifferent="showDifferent"
			:region="region">		
		</batch-open>
		<!-- 批量重启 -->
		<batch-restart 
			:visible.sync="batchRestartVisible"
			@refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection"
			:showDifferent="showDifferent"
			:region="region">		
		</batch-restart>
		<!--批量编辑-->
	    <jcb-tag-edit :visible.sync="batchEditTagDialogVisible"
	        :service-code="ServiceCodeConstant.CPS"
	        :region-id="region"
	        :resource-ids="multipleSelectionId"
	        @complete="batchOperateRefresh">
	    </jcb-tag-edit>
		<!-- 批量重置密码 -->
		<batch-repassword 
			:visible.sync="batchRepasswordVisible"
			@refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection"
			:showDifferent="showDifferent1"
			:region="region">		
		</batch-repassword>
		<!-- 批量编辑实例名称 -->
		<batch-rename 
			:visible.sync="batchRenameVisible"
			@refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection"
			:showDifferent="showDifferent1"
			:region="region">		
		</batch-rename>
		<!--开启实例删除操作保护-->
		<enable-deletion-protection
			:visible.sync="enableDeletionProtectionVisible"
			:instanceName="rowInfo.name"
			:region="rowInfo.region"
			:instanceId="rowInfo.instanceId"
			@refresh="operateRefresh">
		</enable-deletion-protection>
		<!--关闭实例删除操作保护-->
		<disable-deletion-protection
			:visible.sync="disableDeletionProtectionVisible"
			:instanceName="rowInfo.name"
			:region="rowInfo.region"
			:instanceId="rowInfo.instanceId"
			@refresh="operateRefresh">
		</disable-deletion-protection>
  	</div>
</template>

<script>

import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import operateUnit from '@/components/privateNetInstance/operateUnit/OperateUnit';
import custom from '@/components/common/custom/Custom';
import open from '@/components/privateNetInstance/operates/Open';
import close from '@/components/privateNetInstance/operates/Close';
import restart from '@/components/privateNetInstance/operates/Restart';
import repassword from '@/components/privateNetInstance/operates/Repassword';
import reinstall from '@/components/privateNetInstance/operates/ReSystem';
import resys from '@/components/privateNetInstance/operates/ReSysConfirm';
import DeleteInstance from '@/components/common/DeleteInstance';
import PerformanceMonitorIcon from '@/components/common/PerformanceMonitorIcon';
import ResetPassword from '@/components/common/resetPassword/ResetPassword';
import operationProtect from '@/mixins/operationProject';
import isDestroyingMixins from '@/mixins/isDestroying';
import AddAliasIpRangeDialog from
	'@/components/common/addAliasIpRangeDialog/AddAliasIpRangeDialog';
import BatchClose from '@/components/common/BatchClose';
import BatchOpen from '@/components/common/BatchOpen';
import BatchRestart from '@/components/common/BatchRestart';
import BatchRepassword from '@/components/common/BatchRepassword';
import BatchRename from '@/components/common/BatchRename';
import DownloadSelection from '@/components/common/retailInstance/DownloadSelection';
import copyValue from '@/components/privateNetwork/CopyValue';
import EnableDeletionProtection from '@/components/common/enableDeletionProtection/EnableDeletionProtection';
import DisableDeletionProtection from '@/components/common/disableDeletionProtection/DisableDeletionProtection';
import {
  	ServiceCodeConstant,
  	OverdueConstantArray,
	ArrearConstantArray,
	ChargeModeConstant
} from "@/common/Constants";
import { deepCopy } from '@/common/tool'
export default {
  	name: 'RetailInstanceList',
  	mixins:[operationProtect, isDestroyingMixins],
  	components: {
	    PerformanceMonitorIcon,
	    open,
	    close,
	    dropDownOperation,
	    operateUnit,
	    custom,
	    restart,
	    repassword,
	    reinstall,
	    resys,
	    ResetPassword,
	    DeleteInstance,
		BatchClose,
		BatchOpen,
		BatchRestart,
		BatchRepassword,
		BatchRename,
		DownloadSelection,
		copyValue,
		EnableDeletionProtection,
		DisableDeletionProtection
  	},
  	data() {
	    return {
	      	totalCount: 0, // 列表总数
	      	loading: false,
			statusMapName: {
				'creating': this.$t('privateNetInstance.statueNames.creating'),
				'starting': this.$t('privateNetInstance.statueNames.starting'),
				'running': this.$t('privateNetInstance.statueNames.running'),
				'stopping': this.$t('privateNetInstance.statueNames.stopping'),
				'stopped': this.$t('privateNetInstance.statueNames.stopped'),
				'restarting': this.$t('privateNetInstance.statueNames.restarting'),
				'error': this.$t('privateNetInstance.statueNames.error'),
				'upgrading': this.$t('privateNetInstance.statueNames.upgrading'),
				'reinstalling': this.$t('privateNetInstance.statueNames.reinstalling'),
				'destroying': this.$t('privateNetInstance.statueNames.destroying'),
				'resetting_password': this.$t('listPage.text.resettingPassword')
			},
		    azs: [],
	      	interStatus: ['creating', 'starting', 'stopping', 'restarting', 'upgrading',
	        'reinstalling', 'destroying', 'resetting_password'],
			instanceInfo: {},
			rowInfo: {},
			openInstance: false,
			downloadVisible: false,
			closeInstance: false,
			restartInstanceVisible: false,
			repasswordInstance: false,
			reInstall: false,
			retailType:'retail',
			retailTipChange:'retail',
	      	operateMap: {
		        stopped: [
		          'restart'
		        ],
		        running: [
		          'reinstall',
		          'resetPassword',
		          'delete'
		        ],
		        error: [
		          'start',
		          'turnOff',
		          'restart',
		          'resetPassword',
		          'reinstall',
		          'bandWidth',
		          'renew',
		          'editTag',
		          'turnOnDeleteProtect',
		          'turnOffDeleteProtect',
		          'delete',
		        ],
		        creating: [
		          'start',
		          'turnOff',
		          'restart',
		          'resetPassword',
		          'reinstall',
		          'bandWidth',
		          'renew',
		          'editTag',
		          'turnOnDeleteProtect',
		          'turnOffDeleteProtect',		          
		          'delete',
		        ],
		        upgrading: [
		          'start',
		          'turnOff',
		          'restart',
		          'resetPassword',
		          'reinstall',
		          'bandWidth',
		          'renew',
		          'editTag',
		          'turnOnDeleteProtect',
		          'turnOffDeleteProtect',		          
		          'delete',
		        ],
		        destroying: [
		          'start',
		          'turnOff',
		          'restart',
		          'resetPassword',
		          'reinstall',
		          'bandWidth',
		          'renew',
		          'editTag',
		          'turnOnDeleteProtect',
		          'turnOffDeleteProtect',		          
		          'delete',
		        ],
		        other: [
		          'start',
		          'turnOff',
		          'restart',
		          'resetPassword',
		          'reinstall',
		          'bandWidth',
		          // 'renew'
		          'editTag',
		          'turnOnDeleteProtect',
		          'turnOffDeleteProtect',		          
		          'delete',
		        ],
		        noOperate: [
		          'starting',
		          'running',
		          'stopping',
		          'stopped',
		          'error',
		          'restarting',
		          'creating',
		          'destroying',
		          'upgrading',
		          'reinstalling',
		          'turnOnDeleteProtect',
		          'turnOffDeleteProtect',		          
		          'delete',
		        ]
	      	},
			statusListMap: {
				'starting': 'other',
				'running': 'running',
				'stopping': 'other',
				'stopped': 'stopped',
				'error': 'error',
				'restarting': 'other',
				'creating': 'creating',
				'destroying': 'destroying',
				'upgrading': 'upgrading',
				'reinstalling': 'other',
				'noOperate': 'noOperate',
				'other': 'other',
				'resetting_password': 'other',
			},
			operationsRenew: false,
			// 自定义列表弹框显示
			customVisible: false,
			type: 'retailInstanceList',
			statusMap: {
				// 关机
				'shutdown': 'jc-status-warning',
				// 运行
				'run': 'jc-status-success',
				// 中间态
				'intermediate': 'jc-status my-status my-status-middle ',
				// 错误
				'error': 'jc-status-danger',
			},
			placeholderMap: {
				instanceIds: this.$t('privateNetInstance.placeholderId'),
				name: this.$t('privateNetInstance.placeholderName'),
				privateIp: this.$t('list.searchPlaceholder.privateIp')
			},
			region: '',
			regions: [],
			tableData: [],
			searchLists:{
				azs: [],
				interfaceModes: [],
				deviceTypes: [],
				status: []
			},
			filterGroup:
			[
				{	//实例名称
					label: this.$t('privateNetInstance.instanceName'),
					key:"name",
					multiValue:false,
					notice: this.$t('list.fuzzySearchTip')
				},
				{	//实例ID
					label: this.$t('privateNetInstance.instanceID'),
					key:"instanceId",
					multiValue:true,
					notice: this.$t('list.exactSearchTip')
				},
				{	//主IP地址
					label: this.$t('listPage.tableLabel.targetIpAddress'),
					key:"targetIpAddress",
					matchModes:[{
						key:"fuzzy",
						label:this.$t('list.fuzzySearch')
					},{
						key:"exact",
						label:this.$t('list.exactSearch')
					}],
					notice:this.$t('list.IPsearchTip')
				},
				{	//带外管理IP
					label: this.$t('detail.text.iloIp'),
					key:"iloIp",
					multiValue:true,
					notice: this.$t('list.exactSearchTip')
				},
				{	//机柜编码
					label: this.$t('detail.text.cabinet'),
					key:"cabinet",
					multiValue:true,
					notice: this.$t('list.exactSearchTip')
				},
				{	//Net-POD
					label: this.$t('detail.text.podName'),
					key:"podId",
					multiValue:true,
					notice: this.$t('list.exactSearchTip')
				},
				{ 	//网络接口数量
					label:this.$t('create.text.internetAccessType'),
					key:"interfaceMode",
					multiValue:true,
					selectOptions:[],
					notice: this.$t('list.mutisearchTip')
				},
				{ 	//状态
					label:this.$t('list.status'),
					key:"status",
					multiValue:true,
					selectOptions:[],
					notice: this.$t('list.mutisearchTip')
				},
				{ 	//规格类型
					label:this.$t('list.specifications'),
					key:"deviceType",
					multiValue:true,
					selectOptions:[],
					notice: this.$t('list.mutisearchTip')
				},
			],
			defaultKey:"name",
			tags:[],
			params:{},
			netPodList:[],
			searchList:false, 
			copyHover:false,
			filters: {
				azs: [],
				interfaceModes: [],
				deviceTypes: [],
				status: []
			},
			filterParams: {
				az: '',
				interfaceModes: '',
				deviceTypeList: '',
				status: ''
			},
			networkType:'retail',
			currentPage: 1,
			pageSizes: [20, 50, 100],
			pageSize: 20,
	      	optionArr: [
				{
				  // ID/名称
				  label: this.$t('privateNetInstance.listTitle.name'),
				  value: 'id'
				},
				{
				  // 监控
				  label: this.$t('privateNetInstance.listTitle.monitor'),
				  value: 'monitor'
				},
				{
				  // 可用区
				  label: this.$t('privateNetInstance.listTitle.region'),
				  value: 'az'
				},
				{
				  // 机柜编码
				  label: this.$t('detail.text.cabinet'),
				  value: 'cabinet'
				},
				{
					//netPod
					label: this.$t('detail.text.podName'),
				  	value: 'netPod'
				},
				{
					//网络接口数量
					label: this.$t('eip.text.internetAccessType'),
				  	value: 'interfaceMode'
				},
				{
				  // 主IP地址
				  label: this.$t('listPage.tableLabel.targetIpAddress'),
				  value: 'ip'
				},
				{
				  // 网络类型
				  label: this.$t('privateNetInstance.listTitle.netType'),
				  value: 'networkType'
				},
				{
				  // 带外管理IP
				  label: this.$t('detail.text.iloIp'),
				  value: 'iloIp'
				},
				{
				  // 状态
				  label: this.$t('privateNetInstance.listTitle.status'),
				  value: 'status'
				},
				{
				  // 规格
				  label: this.$t('privateNetInstance.listTitle.spc'),
				  value: 'specifications'
				},
				{
				  // 配置
				  label: this.$t('privateNetInstance.listTitle.config'),
				  value: 'config'
				},
				{
				  // 标签
				  label: this.$t('listPage.text.tags'),
				  value: 'tags'
				},
				{
				  // 计费信息
				  label: this.$t('privateNetInstance.listTitle.charge'),
				  value: 'chargeInfo'
				},
				{
				  // 操作
				  label: this.$t('privateNetInstance.listTitle.operate'),
				  value: 'operation'
				}
	      	],
			statusTimeOut: null,
			reSysConfirm: false,
			reSysForm: {},
			reSystemInfo: {},
			resetPasswordDialogVisible: false,
			// 给操作保护用区分物理机类型：basic/vpc
			instanceType: 'vpc',
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 标签过滤后的资源ID
			filteredResourceIds: [],
			// 删除实例弹框
			deleteVisible: false,
			// 多选框选中的实例
			multipleSelection: [],
			multipleSelectionInstanceInfo: {},
			isAllowBatchClose: false,
			isAllowBatchOpen: false,
			isAllowBatchRestart: false,
			isAllowBatchEditTag: false,
			batchCloseVisible: false,
			batchOpenVisible: false,
			batchRestartVisible: false,
			batchEditTagDialogVisible: false,
			batchRepasswordVisible: false,
			batchRenameVisible: false,
			hasCheckAll: false,
			showDifferent:{
				hasCollapse:false,
				ipLabelType:"Ip",
				hasBandWith:false
			},
			showDifferent1:{
				hasCollapse:true,
				ipLabelType:"mainIp",
				hasBandWith:true
			},
			// 开启实例删除操作保护弹框
			enableDeletionProtectionVisible: false,
			// 关闭实例删除操作保护弹框
			disableDeletionProtectionVisible: false,
	    };
  	},
  	computed: {
	    ServiceCodeConstant: () => ServiceCodeConstant,
	    customInfo () {
	    	return this.$store.state.customInfo[this.type];
	    },
	    /**
	     * 返回查询到的列表总数
	     * @return {number}
	    */
	    listTotal() {
	    	return this.totalCount;
	    },
	    OverdueConstantArray: () => OverdueConstantArray,
	    ArrearConstantArray: () => ArrearConstantArray,
		ChargeModeConstant: () => ChargeModeConstant,
		batchOperations() {
			const operations = [{
	        	operateName: this.$t('operations.reset_password.name'),
	    		disabled: !this.isAllowBatchRepassword,
	            tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.repassword') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'repassword'
	        },{
	            operateName: this.$t('privateNetInstance.restart'),
	            disabled: !this.isAllowBatchRestart,
	            tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.restart') : this.$t('retailInstance.tooltip.chooseTips'),
	            value: 'restart'
	        },{
	        	operateName: this.$t('operations.rename.name'),
	    		disabled: !this.isAllowBatchRename,
	            tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.rename') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'rename'
	        },{
	        	operateName: this.$t('operations.edit_tag.name'),
	            disabled: !this.isAllowBatchEditTag,
	            tip: this.multipleSelection.length ? this.$t('operations.edit_tag.tip') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'editTag'
	        }]
	        return operations
	    },
	    multipleSelectionId() {
	    	return this.multipleSelection.map(item => item.instanceId)
	    }
  	},
  	created() {
	    if (this.$store.state.customInfo[this.type] === null) {
	    	this.getCustomInfo();
	    }
	    this.getRegions();
	},
	destroyed() {
		clearTimeout(this.statusTimeOut);
	},
	watch: {
		region(newValue) {
			if(newValue) {
				this.regionChange()
			}
		},
	},
  	methods: {
	    /**
	     **@disc: 根据标签对实例进行过滤
	     **@author: mengln
	    */
	    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
	      if (tagKeys.length !== 0) {
	        this.filteredResourceIds = resourceIds;
	      }
	      this.refreshWithLoading(null, this.filteredResourceIds.length !== 0);
	    },
	    /**
	     * 判断当前时间与到期、释放时间关系
	     * @param row
	     * @return {string}
	    */
	    getCheckExpireInfo(row) {
	      if (row.charge.chargeExpiredTime !== undefined) {
	        const now = Date.now();
	        const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
	        const DAYS = 1000 * 60 * 60 * 24;
	        if (now > expire && row.charge.chargeRetireTime) {
	          return 'will-retire';
	        }
	        if (expire - now > 7 * DAYS) {
	          return 'available';
	        }
	        return 'will-expire';
	      }
	    },
	    /*
	     根据当前状态（返回字段statue）判断单个操作disabled
	    */
	    checkOperationDisable(data, status, chargeStatus) {
			let bool = this.operateMap[this.statusListMap[data.status]].indexOf(status) > -1;
			if (chargeStatus) bool = bool || OverdueConstantArray.includes(data.charge.chargeStatus);
			return bool;
	    },
	    openReConfirm(formInfo, rowInfo) {
			this.reSysForm = formInfo;
			this.reSystemInfo = rowInfo;
			this.reSysConfirm = true;
	      	// this.closeInstance = true;
	    },
	    // 切换可用区
	    regionChange() {
	      	// TODO remember to clear search
			this.tags = [],
			this.params = {},
			this.pageSize = 20;
			this.currentPage = 1;
			this.hasCheckAll = false;
			this.resetMultipleSelection();
			const params = {
				region: this.region,
				networkType: 'retail'
			};
			Object.keys(this.filterParams).forEach((filter) => {
				this.filterParams[filter] = '';
			});
			this.refreshList(params);
			this.getFilterLists();
	    },
	    // 切换搜索条件
	    // 获得可用区
	    getRegions() {
			const params = {
				networkType: 'retail'
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				const target = this;
				if (res.data) {
				  	res.data.regions.forEach((region, index) => {
						if (index === 0) {
							if (target.$route.query && target.$route.query.region) {
								target.region = target.$route.query.region;
							} else {
								target.region = region.region;
							}
						}
						const tempFormat = {};
						tempFormat.region = region.region;
						tempFormat.regionName = region.regionName;
						target.regions.push(tempFormat);
				  	});
				}
			});
	    },
	    // 查询实例列表
	    getInstanceList(params) {
	      	return Ajax.get('/api/cps/listInstances', params).then((res) => {
				if (res.data) {
					// 格式化返回的标签键值对
					for (const item of res.data.instances) {
						item.tagPairs = '';
						if (item.tags !== undefined && item.tags.length > 0) {
							for (const tag of item.tags) {
								item.tagPairs += `${tag.key}:${tag.value},`;
							}
							item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
						}
					  	item.chargeMode = item.charge.chargeMode;

						const operations = [
				          	{
					            operateName: this.$t('privateNetInstance.operations.rePassword'),
					            disabled: this.operateMap[this.statusListMap[item.status]].indexOf('resetPassword') !== -1
					              || OverdueConstantArray.includes(item.charge.chargeStatus)
								  || !item.charge.chargeStatus,
					            tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
										: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
										: this.$t('privateNetInstance.operations.onlyShutDown'),
					            value: 'rePassword'
				          	},
							{
								operateName: this.$t('privateNetInstance.operations.reOperateSystem'),
								disabled: this.operateMap[this.statusListMap[item.status]].indexOf('reinstall') > -1
								  || OverdueConstantArray.includes(item.charge.chargeStatus)
								  || !item.charge.chargeStatus,
								tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
										: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
										: this.$t('privateNetInstance.operations.onlyShutDown'),
								value: 'reInstall'
							},
			          		{
					            operateName: this.$t('privateNetInstance.operations.repay'),
					            disabled: this.operateMap[this.statusListMap[item.status]].indexOf('renew') > -1
					              || !item.charge.chargeStatus,
					            tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') :'',
					            value: 'repay'
			          		},
			          		{
								operateName: this.$t('operations.edit_tag.name'),
								disabled: this.operateMap[this.statusListMap[item.status]].indexOf('editTag') > -1
								|| OverdueConstantArray.includes(item.charge.chargeStatus)
								|| !item.charge.chargeStatus,
								tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('operations.edit_tag.tip'),
								value: 'editTag'
				        	}
			        	];
					    // 开启实例删除保护
						if (item.removeProtect === 'no') {
							const turnOnDeleteProtect = {
								operateName: this.$t('operations.turnOnDeleteProtect.name'),
								disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
								|| !item.charge.chargeStatus
								|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOnDeleteProtect') > -1
								|| this.instanceByConfigOpesDisabled(item),
								value: 'turnOnDeleteProtect',
								tip: ''
							};
							if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
					        	turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
					        }
					        if (this.instanceByConfigOpesDisabled(item)) {
					        	turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.tip')
					        }
							if (!item.charge.chargeStatus) {
								turnOnDeleteProtect.tip = this.$t('eip.help.noChargeInfo')
							}
					        operations.push(turnOnDeleteProtect);
						}
						// 关闭实例删除保护
						if (item.removeProtect === 'yes') {
					        const turnOffDeleteProtect = {
								operateName: this.$t('operations.turnOffDeleteProtect.name'),
								disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
								|| !item.charge.chargeStatus
								|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOffDeleteProtect') > -1
								|| this.instanceByConfigOpesDisabled(item),
								value: 'turnOffDeleteProtect',
								tip: ''
							};
							if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
					        	turnOffDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
					        }
					        if (this.instanceByConfigOpesDisabled(item)) {
					        	turnOffDeleteProtect.tip = this.$t('operations.turnOffDeleteProtect.tip')
					        }
							if (!item.charge.chargeStatus) {
								turnOffDeleteProtect.tip = this.$t('eip.help.noChargeInfo')
							}
					        operations.push(turnOffDeleteProtect);
						}
				        // 删除实例特殊处理
				        const deleteOperate = {
							operateName: this.$t('operations.delete.name'),
							disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
							|| !item.charge.chargeStatus
							|| this.operateMap[this.statusListMap[item.status]].indexOf('delete') > -1
							|| (item.status === 'stopped' && !!item.ipv6AddressId)
							|| item.removeProtect === 'yes',
							value: 'delete',
							tip: ''
				        };
				        if (item.removeProtect === 'yes') {
				        	deleteOperate.tip = this.$t('operations.delete.tipWithRemoveProtect')
				        }
				        if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
				        	deleteOperate.tip = this.$t('operations.delete.tip')
				        }
						if (this.operateMap[this.statusListMap[item.status]].indexOf('delete') > -1) {
							deleteOperate.tip = this.$t('operations.delete.tipWithStatus');
						}
						if (!item.charge.chargeStatus) {
							deleteOperate.tip = this.$t('eip.help.noChargeInfo')
						}
				        operations.push(deleteOperate);
				        item.operations = operations;
					}

					this.tableData = res.data.instances;
					let multipleSelectionInstanceInfo = deepCopy(this.multipleSelectionInstanceInfo)
					this.$nextTick(() => {
			    		this.tableData.map(item => {
							let instanceId = item.instanceId;
							if (multipleSelectionInstanceInfo[instanceId]) {
			        			this.$refs.multipleTable.toggleRowSelection(item,true)
			        		}
						})
			      	})
					this.totalCount = res.data.totalCount;
				}
	        })
	        .catch(async (err) => {
	        	const { response } = err.data;
			  	try {
					const json = await response.json();
					this.$message.error(json.errmsg);
			  	} catch (e) {
					console.log(e);
			  	}
	        })
	        .finally(() => {
	        	this.loading = false
	        });
	    },
	    // 获得过滤
	    getFilterLists() {
			const params = {
				region: this.region,
				networkType: 'retail'
			};
	      	Ajax.get('/api/filter/listInstances', params).then((res) => {
				if (res.errno === 10000 && res.data) {
					Object.keys(res.data).forEach((key) => {
						const filtersArray = []; 
						const filtersObj = res.data[key];
						Object.keys(filtersObj).forEach((item) => {
							const temp = {};
							temp.value = item;
							temp.text = filtersObj[item];
							filtersArray.push(temp);
						});
						this.filters[key] = filtersArray;
						var json = JSON.parse(JSON.stringify(filtersArray).replace(/value/g,"key"))
						this.searchLists[key] = JSON.parse(JSON.stringify(json).replace(/text/g,"label"))
					});	
					this.filterGroup.forEach((item) => {
						if (item.key === 'interfaceMode') {
							item.selectOptions = this.searchLists.interfaceModes;
						}
						if (item.key === 'status') {
							item.selectOptions = this.searchLists.status;
						}
						if (item.key === 'deviceType') {
							item.selectOptions = this.searchLists.deviceTypes;
						}
					})
				}
	        }).finally(() => {
				this.azs = this.filters.azs;	
				this.loading = false;
				this.getNetpodList();
	        });
	    },
	    filterAz(value, row) {
	    	return row.az === value;
	    },
	    filterInterfaceMode(value, row) {
			if(value) {
				this.searchList = true
			}
	    	return row.interfaceMode === value;			
	    },
	    filterStatus(value, row) {
			if(value) {
				this.searchList=true
			}
	    	return row.status === value;
	    },
	    filterDeviceType(value, row) {
			if(value) {
				this.searchList=true
			}
	    	return row.deviceType === value;
	    },
		ipHover() {
			this.copyHover=true
		},
		ipDisplayNone() {
			this.copyHover=false
		},
	    createErrorOrder() {
	    	Normal.goWorkPage();
	    },
	    // 续费
	    renew(id) {
			const params = {
				resourceId: id,
				region: this.region,
				serviceCode: ServiceCodeConstant.CPS,
				resourceName: 'a'
			};
	      	Ajax.get('/api/order/submitRenew', params).then((res) => {
	          const tempOrderId = res.data.tmpOrderId;
	          window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cps`;
	        });
	    },
	    clickOperate(value, rowInfo) {
			this.rowInfo = rowInfo;
			switch (value) {
				case 'rePassword':
					Pop.resetPassword(this, rowInfo);
					break;
				case 'repay':
					this.renew(rowInfo.instanceId);
					break;
				case 'reInstall':
					this.reInstall = true;
					break;
				case 'editTag':
					this.editTagDialogVisible = true;
					break;
				case 'delete':
					this.deleteVisible = true;
					break;
				case 'turnOnDeleteProtect':
					this.enableDeletionProtectionVisible = true;
					break;
				case 'turnOffDeleteProtect':
					this.disableDeletionProtectionVisible = true;
				default:
					break;
	      	}
	    },
	    /**
	     * @param size
	     * 改变当前每页条数时触发
	    */
	    handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1; // 切换每页条数时自动返回第一页
			const params = {
				pageSize: size,
			};
			this.refreshWithLoading(params);
	    },
	    handleCurrentChange(page) {
			this.currentPage = page;
			const params = {
				pageNumber: page
			};
			this.refreshWithLoading(params);
	    },
		handleSearch(tags){
			this.params = {};
			
			tags.map((item) => {
				if(item.key==="instanceId") {
					this.params.instanceIds=item.values.toString();
				}
				if(item.key==="name") {
					this.params.name=item.values.toString();
				}
				if(item.key==="targetIpAddress") {
					this.params.privateIps=item.values.toString();
				}
				if(item.key==="iloIp") {
					this.params.iloIps=item.values.toString();
				}
				if(item.key==="cabinet") {
					this.params.cabinets=item.values.toString();
				}
				if(item.key==="podId") {
					var netPodListIds=[];
					item.values.forEach((item) => {
						this.netPodList.forEach((element) => {
							if(item === element.name) {
								netPodListIds.push(element.id)
							}else {
								netPodListIds.push(-1)
							}
						})
					});
					this.params.podIds = netPodListIds.toString();	
				}
				if(item.key==="interfaceMode") {
					this.params.interfaceModes=item.values.toString();
				}
				if(item.key==="status") {
					this.params.status=item.values.toString();
				}
				if(item.key==="deviceType") {
					this.params.deviceTypeList=item.values.toString();
				}
			});
			this.searchOfList(this.params);
			if(tags.length!==0) {
				this.searchList = true;
			}else {
				this.searchList = false;
			}
        },
		matchKeyFunction(keyValue){
			let instanceIdReg = /^cps-[a-z0-9]/ig
			let ipv4Reg = /^((10|172|192)\.)((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){2}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/
			keyValue = keyValue.replace(/，/g, ',').split(',')[0]
			if(instanceIdReg.test(keyValue)){
				return {
					key: 'instanceId'
				}
			} else if(ipv4Reg.test(keyValue)){
				return {
					key: 'targetIpAddress',
					matchMode: "fuzzy"
				}
			} 
			return false
		
		},
		// 获得NET-POD的id
		getNetpodList() {
			const params = {
	        	region: this.region,
				clientToken: Normal.getClientToken(),
	      	};
	      	Ajax.get('/api/cps/netpods', params).then((res) => {
				this.netPodList = res.data.result
	        }).catch(err => {
	        	console.log(err);
	        })
		},
		// 返回最初列表
		backTolist() {	
			this.tags = [];
			this.params = {};
			this.filterParams = {};
			this.searchList = false;
			this.pageSize = 20;
			this.currentPage = 1;
			this.hasCheckAll = false;
			this.resetMultipleSelection();
			this.$refs.multipleTable.clearFilter();
			this.refreshList();
			this.refreshWithLoading(this.params);
		},
	    // 刷新列表
	    refreshList(params) {
        if (this.isDestroying) {
          return
        }
			const defaultParams = {
				region: this.region,
				networkType: 'retail',
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
	      	Object.keys(this.filterParams).forEach((key) => {
		        if (this.filterParams[key] !== '') {
		          defaultParams[key] = this.filterParams[key];
		        }
	      	});
	      	const realParams = Object.assign({}, defaultParams, this.params, params);
			const timeoutParams = Object.assign({}, defaultParams, this.params);
	      	this.getInstanceList(realParams).then(() => {
		        const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
		        if (refreshTag) {
		        	clearTimeout(this.statusTimeOut);
					this.statusTimeOut = setTimeout(() => {
						this.refreshList(timeoutParams);
					}, 5000);
		        }
	      	});
	    },
	    // 临时增加遮罩层
	    refreshWithLoading(params, ifFilter = false) {
        if (this.isDestroying) {
          return
        }
			this.loading = true;
			const defaultParams = {
				region: this.region,
				networkType: 'retail',
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
	      	if (ifFilter) {
	        	defaultParams.instanceIds = this.filteredResourceIds.join(',');
	      	}
			Object.keys(this.filterParams).forEach((key) => {
				if (this.filterParams[key] !== '') {
				  defaultParams[key] = this.filterParams[key];
				}
			});
	      	const realParams = Object.assign({}, defaultParams, params, this.params);
			const timeoutParams = Object.assign({}, defaultParams, this.params);
			this.getInstanceList(realParams).then(() => {
				this.loading = false;
				const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
				if (refreshTag) {
					clearTimeout(this.statusTimeOut);
				  	this.statusTimeOut = setTimeout(() => {
				    	this.refreshList(timeoutParams);
				  	}, 5000);
				}
			}).finally(() => {
	            this.loading = false
	        })
	    },
		searchOfList(params, ifFilter = false) {
			this.loading = true;
			const defaultParams = {
				region: this.region,
				networkType: 'retail',
				pageNumber: 1,
				pageSize: this.pageSize,
			};
	      	if (ifFilter) {
	        	defaultParams.instanceIds = this.filteredResourceIds.join(',');
	      	}
			Object.keys(this.filterParams).forEach((key) => {
				if (this.filterParams[key] !== '') {
				  defaultParams[key] = this.filterParams[key];
				}
			});
	      	const realParams = Object.assign({}, defaultParams, params, this.params);
			const timeoutParams = Object.assign({}, defaultParams, this.params);
			this.getInstanceList(realParams).then(() => {
				this.loading = false;
				const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
				if (refreshTag) {
					clearTimeout(this.statusTimeOut);
				  	this.statusTimeOut = setTimeout(() => {
				    	this.refreshList(timeoutParams);
				  	}, 5000);
				}
			}).finally(() => {
	            this.loading = false
	        })
	    },
	    iconRefreshList() {
	    	const params = {};
	    	this.refreshWithLoading(params);
	    },
	   	handleSelectionChange(val) {
	   		this.multipleSelection = val;
	   		this.hasCheckAll = val.length === this.tableData.length ? true : false;
	   		let isAllowBatchClose = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'running'&& item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
	   		this.isAllowBatchClose = isAllowBatchClose;
	   		let isAllowBatchOpen = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped'&& item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
	   		this.isAllowBatchOpen = isAllowBatchOpen;
	   		let isAllowBatchRestart = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'running'&& item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
	   		this.isAllowBatchRestart = isAllowBatchRestart; 		
	   		let isAllowBatchEditTag = this.multipleSelection.length ? this.multipleSelection.every(item => this.operateMap[this.statusListMap[item.status]].indexOf('editTag') < 0 && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
	   		this.isAllowBatchEditTag = isAllowBatchEditTag;
			let isAllowBatchRepassword = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
	   		this.isAllowBatchRepassword = isAllowBatchRepassword;
			let isAllowBatchRename = this.multipleSelection.length ? this.multipleSelection.every(item => item.charge.chargeStatus) : false;
	   		this.isAllowBatchRename = isAllowBatchRename;
	   		let multipleSelectionInstanceInfo = {};
	   		this.multipleSelection.map(item => {
	   			multipleSelectionInstanceInfo[item.instanceId] = item;
	   		})
	   		this.multipleSelectionInstanceInfo = multipleSelectionInstanceInfo;
	   	},
	    filterChange(filter) {
	    	this.currentPage = 1;
			//通过列表项的筛选条件自动获得的搜索框的搜索条件
			var tag = {};
            Object.keys(filter).forEach((key) => {
                  console.log( filter[key].toString());
                if (key === 'az') {
                    this.filterParams.az = filter[key].toString();
                } else if (key === 'status') {
                    this.filterParams.status = filter[key].toString();
                } else if (key === 'deviceType') {
                    this.filterParams.deviceTypeList = filter[key].toString();
                } else if (key === 'interfaceMode') {
                    this.filterParams.interfaceModes = filter[key].toString();
                }
                tag.key = key;
                tag.values = filter[key];
                if(this.tags.length === 0 && tag.values.length) {
                    this.tags.push(tag);
                }else {
                    let isAdd = true;
                    this.tags.forEach((item, index) => {
                        if(item.key === tag.key) {
                            item.values = tag.values;
                            if(tag.values.length === 0) {
                                this.tags.splice(index, 1);
                            }
                            isAdd = false;      
                        }
                    })
                    if (isAdd && tag.values.length) {
                        this.tags.push(tag)
                    }
                }
                if(!this.tags.length) {
                    this.searchList=false;
                }
            });

	      	this.refreshList();
	    },
	    // 自定义列
	    getCustomInfo() {
	      	const params = {
	        	pageKey: this.type
	      	};
	      	Ajax.get('/api/usercenter/getCustomInfo', params).then((res) => {
				if (res.data.customInfo) {
					this.$store.commit(
						'GET_CUSTOMINFO',
						{ value: res.data.customInfo, type: this.type }
					);
				}
	        }).catch(err => {
	        	console.log(err);
	        })
	    },
	    clickOperateShutdown(operate, instance) {
			if (!operate) {
				this.instanceInfo = instance;
				Pop.vpcInstance_close(this, instance, 'list');
			}
	    },
	    clickOperateOpen(operate, instance) {
			if (!operate) {
				this.instanceInfo = instance;
				Pop.vpcInstance_open(this, instance, 'list');
			}
	    },
	    clickOperateRestart(operate, instance) {
			if (!operate) {
				this.instanceInfo = instance;
				Pop.vpcInstace_restart(this, instance, 'list');
			}
	    },
	    operateRefresh() {
	    	this.refreshWithLoading({});
	    },
	    checkExpire(row) {
	      	if (row.charge.chargeExpiredTime !== undefined) {
		        const nowDate = new Date();
		        const expireDate = new Date(row.charge.chargeExpiredTime);
		        const retireDate = new Date(row.charge.chargeRetireTime);
		        const nowTime = nowDate.getTime();
		        const expireTime = expireDate.getTime();
		        const retireTime = retireDate.getTime();
		        if (retireTime - nowTime < 7 * 24 * 3600 * 1000) {
		          return 'will-retire';
		        }
		        if (expireTime - nowTime < 7 * 24 * 3600 * 1000) {
		          return 'will-expire';
		        }
		        return 'available';
	      	}
	    },
	    transformCharge(payMethod) {
	      	switch (payMethod) {
		        case 'prepaid_by_duration':
		        	return this.$t('privateNetInstance.monthAndYear');
		        case 'postpaid_by_duration':
		        	return this.$t('create.text.byConfigurations');
		        default:
		        	return '';
	      	}
	    },

	    jumpToCreate() {
		    this.$router.push({
	        	path: '/instance/retail/create',
	        	query: { region: this.region }
		    });
	    },

	    jumpToInstanceDetail(id, region, az, sn, tabName = 'sourceInfo', imageType,cpsType = 'cps-retail') {
	      	this.$router.push({
		        path: '/instance/retail/detail/performance',
		        query: {
					id,
					region,
					az,
					sn,
					tabName,
					imageType,
					cpsType
		        }
	      	});
	    },
	    transformDeviceType(device) {
	      	switch (device) {
		        case 'storage':
		          	return this.$t('privateNetInstance.types.storage');
		        case 'gpu':
		          	return this.$t('privateNetInstance.types.GPU');
		        case 'compute':
		          	return this.$t('privateNetInstance.types.compute');
		        default:
		          	return '';
	      	}
	    },
	    transformAz(vaule) {
	      	let realAz;
	      	this.azs.forEach((az) => {
		        if (az.value === vaule) {
		        	realAz = az.text;
		        }
	      	});
	      	return realAz;
	    },
	    getRegionName(region) {
	      	let regionName = '';
	      	this.regions.forEach((item) => {
				if (region === item.region) {
				  	regionName = item.regionName;
				}
	      	});
	      	return regionName;
	    },
	    getClassByStatue(status) {
	      	switch (status) {
				case 'running':
					return ['jc-status-success'];
				case 'error':
					return ['jc-status-danger'];
				case 'stopped':
					return ['jc-status-warning'];
				default:
					return ['my-status', 'my-status-middle'];
	      	}
	    },
	    transFormStatusName(status) {
	      return this.statusMapName[status];
	    },
	    /**
			* 当按配置购买的实例处于欠费状态时
			* 除删除操作外，其余操作置灰
			* @param item
			* @return {boolean}
		*/
		instanceByConfigOpesDisabled(item) {
			return item.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION
				&& OverdueConstantArray.includes(item.charge.chargeStatus);
		},

		resetMultipleSelection() {
			this.multipleSelection = [];
			this.multipleSelectionInstanceInfo = {};

		},

		batchOperateRefresh() {
			this.resetMultipleSelection();
			this.refreshWithLoading({});
		},

		showBatchCloseDialog() {
			this.batchCloseVisible = true;
		},

		showBatchOpenDialog() {
			this.batchOpenVisible = true;
		},

		showBatchOpenRestart() {
			this.batchRestartVisible = true;
		},

		showDownload() {
			this.downloadVisible = true;
		},

		handleCheckAllChange(event) {
			this.tableData.map(item => {
        		this.$refs.multipleTable.toggleRowSelection(item,event)
			})
		},
		clickBatchOperate(value) {
			console.log(value)
			switch (value) {
				case 'restart':
					this.batchRestartVisible = true;
					break;
				case 'editTag':
					this.batchEditTagDialogVisible = true;
					break;
				case 'repassword':
					this.batchRepasswordVisible = true;
					break;
				case 'rename':
					this.batchRenameVisible = true;
					break;
				default:
					break;
	      	}
		}
  	},

};
</script>

<style lang="scss">
  @import '../../../assets/scss/listComon';
  @import '../../../assets/scss/paginationCommon';
  @import '../../../assets/scss/sliderCommon';
  @import '../../../assets/scss/statusCommon';
  @import 'style';
</style>



// WEBPACK FOOTER //
// src/views/retailInstance/list/RetailInstanceList.vue